import React, { useEffect, useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import Layout from "../../components/Layout";
import { callAPI } from '../../helper/apiUtils';
import LanguageContext from '../../helper/LanguageContext';
import { DE } from '../../Languages/DE';
import { EN } from '../../Languages/EN';
import { corporateForms } from '../../Languages/vars/Corporate';
import { Positions } from '../../Languages/vars/Positions';
import LocationSearchInput from "../../components/LocationSearchInput";
import { Roles } from "../../Languages/vars/Roles";
import SuggestionInput from "./SuggestionInput";
import { $crud } from "../../helper/CrudFactory";
import { Link, useHistory } from 'react-router-dom';
import { BASE_URL, KJUUP_COLORS } from "../../helper/constants";
import ImageCropper from "../Profile/ImageCropper";
import CompanyRoles from "./Dialogs/CompanyRoles";
import CompanyCorporateDialog from "./Dialogs/CompanyCorporateDialog";
import CompanyPositionDialog from "./Dialogs/CompanyPositionDialog";
import { $user } from "../../helper/UserFactory";
import { convertBranchRole, convertCorporateForm, convertRole } from '../../helper/convertor';
import { getCompanyRoles, loadCustomBranches } from '../../helper/customBranches';
import { Discuss, Rings, Oval } from 'react-loader-spinner'
import "./EditCompany.css";
function EditCompany(props) {
    // Back icon replaced with Material Symbol - see usage below
    const [companyRoles, setCompanyRoles] = useState(Roles);

    useEffect(() => {
        loadCustomBranches().then(() => setCompanyRoles(getCompanyRoles()));
    }, []);

    const [params, setParams] = useState({
        logo: '',
        position: "",
        name: "",
        email: "",
        website: "",
        corporateForm: "",
        branch: "",
        street: "",
        postCode: "",
        city: "",
        country: "",
        lat: "",
        long: "",
        houseNo: "",
        full_address: ""
    });
    const [paramsLoaded, setParamsLoaded] = useState({
        name: false,
        email: false,
        corporateForm: false,
        branch: false,
    })
    const user = $user.get();
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({
        position: "",
        name: "",
        email: "",
        corporateForm: "",
        branch: "",
        street: "",
        postCode: "",
        city: "",
        country: "",
        lat: "",
        long: "",
        houseNo: "",
        full_address: ""
    })
    const { isGerm, strings } = React.useContext(LanguageContext)
    const [show, setShow] = useState(false)
    const setParam = (name, value) => {
        console.log(value)
        setParams(prev => {
            return {
                ...prev,
                [name]: value
            }
        })
        setErrors(prev => {
            return {
                ...prev,
                [name]: ''
            }
        });
    }
    const [suggestionLoaded, setSuggestionLoaded] = useState(false)
    const [ownerId, setOwnerId] = useState(null)
    const [mainVal, setMainVal] = useState('');
    const [full_address, setFullAddress] = useState('');
    const [searchCity, setSearchCity] = useState('');

    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;
        //Role
        if (!params.position) {
            formIsValid = false;
            errors["position"] = strings.invalid_fiels;
        }
        //Firstname
        if (!params.name) {
            formIsValid = false;
            errors["name"] = strings.invalid_fiels;
        }
        if (!params.email) {
            formIsValid = false;
            errors["email"] = strings.invalid_fiels;
        }

        if (!params.branch) {
            formIsValid = false;
            errors["branch"] = strings.invalid_fiels;
        }

        if (!params.full_address) {
            formIsValid = false;
            errors["full_address"] = strings.invalid_fiels;
        }

        setErrors(errors);
        return formIsValid;
    }
    const corporateForm = corporateForms;
    const [isInvalid, setIsInvalid] = useState(false);
    const [invalidMsg, setInvalidMsg] = useState("")
    const [showCorporateForm, setCorporateForm] = useState(false)
    const [showPositionDialog, setPositionDialog] = useState(false)
    const [roleSelected, setRoleSelected] = useState(false)
    const [companies, setCompanies] = useState([])
    const history = useHistory();
    const [isUploadingFile, setIsUploadFile] = useState(false)
    const [mcomp, setMcomp] = useState({})

    const requestConfirmation = async () => {
        setLoading(true);
        console.log(params)
        if (handleValidation()) {
            try {
                const id = props.match.params.id
                const payload = {
                    ...params,
                    website: (params.website || "").trim(),
                }
                const { data } = await callAPI('/company/' + id, null, 'PUT', payload)
                if (!data.status) {
                    setInvalidMsg(data.message);
                    setIsInvalid(true)
                    await $crud.notify({
                        type: 'error',
                        message: data.message
                    })
                } else {
                    history.push({ pathname: "/cockpit", search: `?tab=company&company=${encodeURIComponent(id)}` })
                }
            } catch (e) {
                console.log(e)
            }
            setLoading(false);
        } else {
            console.log(errors)
        }
    }

    const changeImage = async (file) => {

        console.log(file)
        if (file) {
            setIsUploadFile(true)
            const id = props.match.params.id
            let formData = new FormData()
            formData.append('file', file);
            formData.append('id', id);
            $crud.put(`/company/${id}/logo`, formData).then(res => {
                console.log(res)
                getCompanyDetails()
            }).catch(() => {
                setIsUploadFile(false)
            })
            setShow(false);
        } else {
            $crud.notify({
                type: 'error',
                message: strings.please_select_file
            })
        }

    }

    console.log(mcomp)

    const getCompanyDetails = async () => {
        const id = props.match.params.id
        const { data: { profile } } = await callAPI(`/company/${id}/profile`, {}, 'GET')
        const company = profile
        setMcomp(company)
        let suggestion = company
        let add = `${suggestion.houseNo ? suggestion.houseNo + "," : ""} ${suggestion.street}, ${suggestion.city}, ${suggestion.postCode ? suggestion.postCode + "," : ""} ${suggestion.country ? suggestion.country : ''}`
        setFullAddress(company.full_address ? company.full_address : add)
        setMainVal(company.full_address ? company.full_address : add)
        await setParams(prev => {
            return {
                ...prev,
                name: company.companyName,
                logo: company.avatar,
                email: company.email,
                website: company.website || "",
                corporateForm: company.corporateForm,
                position: company.position,
                branch: company.branch,
                street: company.street,
                postCode: company.postCode,
                city: company.city,
                country: company.country,
                lat: company.lat,
                long: company.long,
                houseNo: company.houseNo,
                full_address: company.full_address ? company.full_address : add
            }
        })
        setIsUploadFile(false)
    }
    useEffect(() => {
        getCompanyDetails();
    }, [props.match.params.id]);

    const getList = async () => {
        try {
            const { data } = await callAPI('/company/getRegisterOrUnregisteredCompany', {}, 'GET')
            console.log(data)
            if (data.status) {
                setCompanies(data.companies)
            }
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        getList()
    }, [])

    const applyAddressSuggestion = (addr) => {
        setMainVal(addr.description)
        setFullAddress(addr.description)
        setParams((prev) => ({
            ...prev,
            full_address: addr.description,
            street: addr.street || "",
            houseNo: addr.houseNo || "",
            city: addr.city || "",
            postCode: addr.postCode || "",
            country: addr.country || "",
            lat: addr.lat || "",
            long: addr.long || "",
        }))
        setErrors((prev) => ({ ...prev, full_address: "" }))
    }

    const getSuggestion = async suggestion => {
        setParams(prev => {
            return {
                ...prev,
                position: '',
                name: suggestion.name,
                email: suggestion.email,
                website: suggestion.website || "",
                corporateForm: suggestion.corporateForm,
                branch: suggestion.branch,
                street: suggestion.street,
                postCode: suggestion.postCode,
                city: suggestion.city,
                country: suggestion.country ? suggestion.country : 'germany',
                lat: suggestion.lat,
                long: suggestion.long,
                houseNo: suggestion.houseNo
            }
        })
        setOwnerId(suggestion.ownerId)
        setParamsLoaded(prev => {
            return {
                ...prev,
                corporateForm: !!suggestion.corporateForm,
                branch: !!suggestion.branch,
                email: !!suggestion.email,
            }
        })
        await setSuggestionLoaded(true)
    }
    const changeRole = roles => {
        setRoleSelected(false);
        // CompanyRoles always emits English name_en values — persist those as-is.
        setParam('branch', (roles || []).join(","));
    }
    
    const handleRolesChange = (roles) => {
        // Update instantly when roles are selected
        const selectedRoles = roles.join(",");
        setParam('branch', selectedRoles);
    }
    return (
        <React.Fragment>
            <style>{`
                .edit-company-container .edit-company-content::-webkit-scrollbar {
                    display: none;
                }
                .edit-company-container .edit-company-content {
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                }
                .edit-company-logo-section {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin: 8px 0 24px;
                }
                .edit-company-logo-wrap {
                    position: relative;
                    width: 96px;
                    height: 96px;
                    flex-shrink: 0;
                    border-radius: 50%;
                }
                .edit-company-logo-wrap .edit-company-logo,
                .edit-company-logo-wrap .company_img_placeholder,
                .edit-company-logo-wrap .edit-company-logo-loading {
                    width: 96px !important;
                    height: 96px !important;
                    min-width: 96px !important;
                    min-height: 96px !important;
                    border-radius: 50% !important;
                    object-fit: cover;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 !important;
                    cursor: pointer;
                }
                .edit-company-logo-wrap .company_img_placeholder .material-symbols-outlined {
                    font-size: 40px;
                    width: 40px;
                    height: 40px;
                }
                .edit-company-logo-pen {
                    position: absolute !important;
                    top: -2px;
                    right: -2px;
                    left: auto !important;
                    max-width: none !important;
                    width: 28px;
                    height: 28px;
                    display: flex !important;
                    align-items: center;
                    justify-content: center;
                    background: #fff;
                    border-radius: 50%;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.18);
                    z-index: 2;
                    cursor: pointer;
                }
                .edit-company-logo-pen .material-symbols-outlined {
                    font-size: 18px !important;
                    width: 18px !important;
                    height: 18px !important;
                    color: #737373;
                }
                .edit-company-logo-pen:hover .material-symbols-outlined {
                    color: var(--kjuup-accent);
                }
            `}</style>
                <div className={`add_company edit-company-container edit-company d-flex flex-column ${mcomp.isKjuup ? 'internal' : ''}`}>
                    <div className="company_header edit-company__header">
                        <div className="heading_icon m-0">
                            <Link to={{ pathname: "/cockpit", search: `?tab=company&company=${encodeURIComponent(props.match.params.id)}` }} className="main_heading">
                                <span 
                                    className="material-symbols-outlined material-arrow-left edit-company__back"
                                >
                                    keyboard_arrow_left
                                </span>
                                {strings.edit_company_details}
                            </Link>
                        </div>
                    </div>
                    <div className="edit-company-content edit-company__content">
                        <div className="edit-company-logo-section">
                            <div className="edit-company-logo-wrap">
                                {!isUploadingFile ?
                                    (params.logo ? (
                                        <img
                                            className="edit-company-logo"
                                            onClick={() => setShow(true)}
                                            src={BASE_URL + params.logo}
                                            alt="Company logo"
                                        />
                                    ) : (
                                        <div
                                            className="company_img_placeholder pointer"
                                            aria-hidden="true"
                                            onClick={() => setShow(true)}
                                            role="button"
                                            tabIndex={0}
                                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setShow(true); }}
                                        >
                                            <span className="material-symbols-outlined">image</span>
                                        </div>
                                    ))
                                    :
                                    <div className="edit-company-logo-loading">
                                        <Oval
                                            height={40}
                                            width={40}
                                            color={KJUUP_COLORS.base_color}
                                            wrapperStyle={{ alignSelf: "center" }}
                                            wrapperClass=""
                                            visible={true}
                                            ariaLabel='oval-loading'
                                            secondaryColor={"#fff"}
                                            strokeWidth={5}
                                            strokeWidthSecondary={5}
                                        />
                                    </div>
                                }
                                <a
                                    onClick={() => setShow(true)}
                                    className="edit-company-logo-pen pointer"
                                    aria-label={strings.select_profile_image}
                                >
                                    <span
                                        className="material-symbols-outlined edit-company__pen-icon"
                                    >
                                        edit
                                    </span>
                                </a>
                            </div>
                        </div>
                        <div className="form-bottom" onSubmit={(e) => {
                            e.preventDefault();
                            requestConfirmation();
                        }}>
                            <Form className="add_company_from">
                                <Form.Group controlId="formBasicEmail">
                                    <SuggestionInput value={params.name} setParam={setParam} setSuggestion={getSuggestion} />
                                    {
                                        errors.name &&
                                        <small className="pl-2 text-danger">{errors.name}</small>
                                    }
                                </Form.Group>
                                <Form.Group controlId="formBasicPassword11" className="edit-company__address-group">
                                    <LocationSearchInput
                                        isInternal={mcomp.isKjuup}
                                        custom
                                        defaultValue={full_address}
                                        placeHolder={strings.Address}
                                        setVal={(val) => {
                                            setMainVal(val)
                                            setSearchCity(val)
                                            setParam('full_address', val)
                                        }}
                                        val={mainVal}
                                        setFull={(val) => {
                                            setMainVal(val)
                                            setParam('full_address', val)
                                            setFullAddress(val)
                                        }}
                                        onAddressSelect={applyAddressSuggestion}
                                    />
                                    {
                                        errors.full_address &&
                                        <small className="pl-2 text-danger">{errors.full_address}</small>
                                    }
                                </Form.Group>
                                <Form.Group className="select_coustom position-relative role-search-form-group">
                                    {(!paramsLoaded.branch || user?.id === ownerId) ? (
                                        <CompanyRoles
                                            searchMode={true}
                                            selectedRoles={params.branch}
                                            hideRoles={() => {}}
                                            setRoles={setRoleSelected}
                                            selectPosition={changeRole}
                                            position={companyRoles}
                                            isKjuup={mcomp.isKjuup}
                                            onRolesChange={handleRolesChange}
                                        />
                                    ) : (
                                        <div className="register_role edit-company__branch-readonly">
                                            {params.branch && <span>{params.branch?.split(",")?.map((itm, index) => (index ? ", " : "") + convertBranchRole(itm, isGerm))}</span>}
                                        </div>
                                    )}
                                    {errors.branch && (
                                        <small className="pl-2 text-danger">{errors.branch}</small>
                                    )}
                                </Form.Group>
                                <Form.Group controlId="formBasicPassword">
                                    <Form.Control disabled={paramsLoaded.email && user?.id !== ownerId} value={params.email}
                                        onChange={e => setParam('email', e.target.value)}
                                        type="text" placeholder={strings.company_e_mail} />
                                    {
                                        errors.email &&
                                        <small className="pl-2 text-danger">{errors.email}</small>
                                    }
                                </Form.Group>
                                <Form.Group controlId="formCompanyWebsite">
                                    <Form.Control
                                        value={params.website || ""}
                                        onChange={e => setParam('website', e.target.value)}
                                        type="text"
                                        placeholder={strings.website_optional || `${strings.website} (${strings.optional || 'optional'})`}
                                        autoComplete="off"
                                    />
                                </Form.Group>
                                <button className={mcomp.isKjuup ? "kj-btn kj-btn--outline kj-btn--internal btn-fixed-300" : "kj-btn kj-btn--outline"}
                                    type="submit">
                                    {strings.update}
                                </button>
                            </Form>
                        </div>
                    </div>
                </div>
                {
                    showPositionDialog &&
                    <CompanyPositionDialog isKjuup={mcomp.isKjuup} handleClose={e => setPositionDialog(false)} setParam={setParam}
                        positions={Positions} />
                }
            <>
                <Modal
                    show={show}
                    onHide={() => setShow(false)}
                    dialogClassName="avatar-picker-modal"
                    aria-labelledby="example-custom-modal-styling-title"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="example-custom-modal-styling-title">
                            {isGerm ? "Logo zuschneiden" : "Crop logo"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ImageCropper mode="logo" changeImage={changeImage} onClose={() => setShow(false)} />
                    </Modal.Body>
                </Modal>
            </>
        </React.Fragment>
    );
}

export default EditCompany;
